import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { useCreateMenuItemMutation, useGetMenuItemByIdQuery, useUpdateMenuItemMutation } from "../Apis/menuItemApi";
import { MainLoader } from "../Components/Page/Common";
import { inputHelper, toastNotify } from "../Helper";
import { userModel } from "../Interfaces";
import { RootState } from "../Storage/Redux/store";
import { SD_Categories, SD_Roles } from "../Utility/SD";
import Forbidden from "./Forbidden";

const Categories = [
  SD_Categories.MEALS,
  SD_Categories.TIFFEN,
  SD_Categories.FASTFOOD,
  SD_Categories.SNACKS,
];

const menuItemData = {
  name: "",
  description: "",
  specialTag: "",
  category: Categories[0],
  price: "",
};

function MenuItemUpsert() {
  const { id } = useParams();

  const navigate = useNavigate();
  const [imageToStore, setImageToStore] = useState<any>();
  const [imageToDisplay, setImageToDisplay] = useState<string>("");
  const [menuItemInputs, setMenuItemInputs] = useState(menuItemData);
  const [imgURL, setURL] = useState("");
  const [imgValue, setImgValue] = useState("Click to Upload Image")
  const [loading, setLoading] = useState(false);
  const [createMenuItem] = useCreateMenuItemMutation();
  const [updateMenuItem] = useUpdateMenuItemMutation();
  const { data } = useGetMenuItemByIdQuery(id);


  const userData: userModel = useSelector(
    (state: RootState) => state.userAuthStore
  );

  useEffect(() => {
    if (data && data.result) {
      const tempData = {
        name: data.result.name,
        description: data.result.description,
        specialTag: data.result.specialTag,
        category: data.result.category,
        price: data.result.price,
      };
      setMenuItemInputs(tempData);
      setImageToDisplay(data.result.image);
      setURL(data.result.image);
    }
  }, [data]);

  const handleMenuItemInput = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const tempData = inputHelper(e, menuItemInputs);
    setMenuItemInputs(tempData);
  };

  function showUploadWidget() {
    (window as any).cloudinary.openUploadWidget({
       cloudName: "vcart",
       uploadPreset: "pasigo",
       sources: [
           "local",
           "url",
           "google_drive"
       ],
       googleApiKey: "<image_search_google_api_key>",
       showAdvancedOptions: false,
       cropping: false,
       multiple: false,
       defaultSource: "local",
       styles: {
           palette: {
               window: "#1B203A",
               sourceBg: "#1A2A45",
               windowBorder: "#7171D0",
               tabIcon: "#79F7FF",
               inactiveTabIcon: "#8E9FBF",
               menuIcons: "#CCE8FF",
               link: "#72F1FF",
               action: "#5333FF",
               inProgress: "#00ffcc",
               complete: "#33ff00",
               error: "#cc3333",
               textDark: "#000000",
               textLight: "#ffffff"
           },
           fonts: {
               default: null,
               "sans-serif": {
                   url: null,
                   active: true
               }
           }
       }
   },
   (err : any, info: any) => {
    if (!err) {
      if (info.event === "success") {
       setURL(info.info.url)
        toastNotify("Image Uploaded Successfully","success")
        setImgValue("Uploaded!!");
        (document.getElementById("imgupload") as HTMLInputElement).disabled = true
      }
    }
  }
  )}

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    if (imgURL==="" && !id) {
      toastNotify("Please upload an image", "error");
      setLoading(false);
      return;
    }

    const formData = new FormData();

    formData.append("Name", menuItemInputs.name);
    formData.append("Description", menuItemInputs.description);
    formData.append("SpecialTag", menuItemInputs.specialTag ?? "");
    formData.append("Category", menuItemInputs.category);
    formData.append("Price", menuItemInputs.price);
    formData.append("Image", imgURL);

    let response;

    if (id) {
      //update
      formData.append("Id", id);
      response = await updateMenuItem({ data: formData});
      toastNotify("Menu Item updated successfully", "success");
    } else {
      //create
      console.log("data----", formData)
      response = await createMenuItem(formData);
      console.log("response-----",response)
      toastNotify("Menu Item created successfully", "success");
    }

    if (response) {
      setLoading(false);
      navigate("/menuItem/menuitemlist");
    }

    setLoading(false);
  };

  return (
    <>
    {userData.role == SD_Roles.ADMIN?
    <>
    <div className="container border mt-5 p-5 bg-light">
      {loading && <MainLoader />}
      <h3 className=" px-2 text-success">
        {id ? "Edit Menu Item" : "Add Menu Item"}
      </h3>
      <form method="post" encType="multipart/form-data" onSubmit={handleSubmit}>
        <div className="row mt-3">
          <div className="col-md-7">
            <input
              type="text"
              className="form-control"
              placeholder="Enter Name"
              required
              name="name"
              value={menuItemInputs.name}
              onChange={handleMenuItemInput}
            />
            <textarea
              className="form-control mt-3"
              placeholder="Enter Description"
              name="description"
              rows={10}
              value={menuItemInputs.description}
              onChange={handleMenuItemInput}
            ></textarea>
            <input
              type="text"
              className="form-control mt-3"
              placeholder="Enter Special Tag"
              name="specialTag"
              value={menuItemInputs.specialTag}
              onChange={handleMenuItemInput}
            />
            <select
              className="form-control mt-3 form-select"
              placeholder="Enter Category"
              name="category"
              value={menuItemInputs.category}
              onChange={handleMenuItemInput}
            >
              {Categories.map((category) => (
                <option value={category}>{category}</option>
              ))}
            </select>
            <input
              type="number"
              className="form-control mt-3"
              required
              placeholder="Enter Price"
              name="price"
              value={menuItemInputs.price}
              onChange={handleMenuItemInput}
            />
            <input
              type="button"
              onClick={()=>{showUploadWidget()}}
              className="form-control mt-3"
              value= {imgValue}
              id="imgupload"
            />
            <div className="row">
              <div className="col-6">
                <button
                  type="submit"
                  className="btn btn-success form-control mt-3"
                >
                  {id ? "Update" : "Create"}
                </button>
              </div>
              <div className="col-6">
                <a
                  onClick={() => navigate("/menuItem/menuitemlist")}
                  className="btn btn-secondary form-control mt-3"
                >
                  Back to Menu Items
                </a>
              </div>
            </div>
          </div>
          <div className="col-md-5 text-center">
            <img
              src={imageToDisplay}
              style={{ width: "100%", borderRadius: "30px" }}
              alt=""
            />
          </div>
        </div>
      </form>
    </div>
    </>:
    <>
    <Forbidden/>
    </>}
    </>
  );
}

export default MenuItemUpsert;